import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "@/components/ui/table";
import StringUtils from "@/utility/StringUtils";

interface ChartOptions {
  title: string;
  xAxisKey: string;
  xAxisTitle: string;
  yAxisKey: string;
  yAxisTitle: string;
}

interface DataTableProps {
  data: any[];
  options: ChartOptions;
}

// Helper function to get nested property value using dot notation
const getNestedValue = (obj: any, path: string): any => {
  if (!path) return obj;

  const keys = path.split(".");
  let value = obj;

  for (const key of keys) {
    if (value === null || value === undefined) return undefined;
    value = value[key];
  }

  return value;
};

export function DataTable({ data, options }: DataTableProps) {
  if (!data || data.length === 0) {
    return (
      <div className="text-center p-4 text-gray-500">No data available</div>
    );
  }

  const columns = Object.keys(data[0]).map((key) => ({
    key: key,
    title: StringUtils.startCase(key)
  }));

  return (
    <div className="border rounded-lg">
      <div className="p-3 sm:p-4 border-b">
        <h3 className="text-base sm:text-lg font-semibold">{options.title}</h3>
      </div>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              {columns.map((column) => (
                <TableHead key={column.key} className="capitalize">
                  {column.title}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index}>
                {columns.map((column) => {
                  const value = getNestedValue(row, column.key);
                  return (
                    <TableCell key={column.key}>
                      {typeof value === "object" && value !== null
                        ? JSON.stringify(value)
                        : value === null || value === undefined || value === ""
                          ? "Unknown"
                          : value}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
